module.exports = __webpack_public_path__ + "img/logo-mgreward-cn.a2cc640e.svg";